import { render, staticRenderFns } from "./LandingNoListFR-V3.vue?vue&type=template&id=6072784e&scoped=true"
import script from "./LandingNoListFR-V3.vue?vue&type=script&lang=js"
export * from "./LandingNoListFR-V3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6072784e",
  null
  
)

export default component.exports